import { render } from "./Results6.vue?vue&type=template&id=a50f1d70&scoped=true"
import script from "./Results6.vue?vue&type=script&lang=js"
export * from "./Results6.vue?vue&type=script&lang=js"

import "./Results6.vue?vue&type=style&index=0&id=a50f1d70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a50f1d70"]])

export default __exports__